// Las pantallas arman HTML con template strings, asi que todo texto que venga
// de la base pasa por aca antes de entrar. Un nombre de proyecto con un < no
// puede romper la pagina.

export function esc(s: unknown): string {
  if (s === null || s === undefined) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
